import { render, staticRenderFns } from "./SurfaceDesignPrints.vue?vue&type=template&id=32159768"
import script from "./SurfaceDesignPrints.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignPrints.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignPrints.vue?vue&type=style&index=0&id=32159768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports